/*
 * Module for handling individual campaign
 */

define([
  "marionette",
  "messaging/messenger",
  "./campaignView",
  "./campaignInfo/campaignInfoModule",
  "./campaignLaunch/campaignLaunchModule",
  "modules/shared/sortableList/sortableListModule",
], function (Marionette, Messenger, CampaignView, CampaignInfoModule, CampaignLaunchModule) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "campaign";
      this.region = options.region;
      this.campaign = null;
      this._setUpVents();
    },
    show: function (campaign) {
      this.layout = new CampaignView.campaignLayout();
      this.campaign = campaign;

      this.campaignInfo = this.addSubModule(
        new CampaignInfoModule({ region: this.layout.campaignInfo, model: campaign }),
      );

      if (!campaign.isNew()) {
        this.campaignLaunch = this.addSubModule(
          new CampaignLaunchModule({
            region: this.layout.campaignLaunch,
            model: campaign,
            namespace: this.name,
          }),
        );
      }

      this.layout.on("show", () => {
        this._showSubViews(campaign);
      });

      this.showRegion(this.layout);
    },
    _showSubViews: function (campaign) {
      this.campaignInfo.show();
      if (!campaign.isNew()) {
        this.campaignLaunch.show(campaign);
      }
    },
    _setUpVents: function () {
      Messenger.vent.on("campaign:selected", (campaign) => this.show(campaign));
    },
  });
});
